import { createApp } from 'vue';
import DatePickerComponent from './App.vue';

const mountElement = document.getElementById('date-picker-app');
if (mountElement) {
    const app = createApp(DatePickerComponent);
    app.mount('#date-picker-app');
}
